import { Moment } from "moment";
import { StudentPost } from "./student-post";
import Decimal from 'decimal.js';
import { InsuranceSupplier } from "./insurance-supplier";

export class BookingPost {

    constructor(
        public startDate: Moment,
        public endDate: Moment,
        public schoolId: number,
        public destinationId: number,
        public student: StudentPost,
        public salesAgentId: number,
        public accommodationTypeId: number,
        public roomTypeId: number,
        public boardTypeId: number,
        public dueAmount: Decimal | null,
        public travelInsuranceSupplier: InsuranceSupplier | null,
        public deposit: Decimal | null,
        public dueDate: Moment | null,
        public languageLevelId: number | null,
        public languageCourseId: number
    ){}

}
